import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-toast',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
   <div class="fixed bottom-5 -translate-x-1/2 left-1/2 z-[9999]" *ngIf="showToast">
  <div
    class="flex items-center text-white px-4 py-2 rounded-lg shadow-lg min-w-[400px]"
    [ngClass]="[
      toastClasses[toastType],
      translate.currentLang === 'ar' ? 'flex-row-reverse' : 'flex-row'
    ]"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <!-- Icon -->
    <span
      class="w-6 h-6"
      [ngClass]="translate.currentLang === 'ar' ? 'ml-3' : 'mr-3'"
    >
      <img [src]="iconSrc" [alt]="toastType + ' icon'" class="w-6 h-6">
    </span>

    <!-- Text -->
    <span
      class="flex-1 font-medium"
      [ngClass]="translate.currentLang === 'ar' ? 'mr-2 text-right' : 'ml-2 text-left'"
    >
      {{ title }}
    </span>
  </div>
</div>
  `,
})
export class ToastComponent {
  toastType: 'success' | 'danger' | 'warning' = 'success';
  showToast = false;
  title = '';
  iconSrc: string = 'assets/icons/tick.svg'; // Default icon source
  @Output() toastClosed = new EventEmitter<void>();
  public readonly translate = inject(TranslateService);

  toastClasses: Record<string, string> = {
    success: 'bg-[#0bba6d]',
    danger: 'bg-[#b3261e]',
    warning: 'bg-[#ff9500]',
  };

  triggerToast(type: 'success' | 'danger' | 'warning', title: string, timeout: number = 60000) {
    this.toastType = type;
    this.title = title;
    this.showToast = true;

    // Set the icon source based on the toast type
    switch (type) {
      case 'success':
        this.iconSrc = 'icons/tick.svg'; // Success icon
        break;
      case 'danger':
        this.iconSrc = 'icons/close-circle-white.svg'; // Danger icon
        break;
      case 'warning':
        this.iconSrc = 'icons/exclaimation mark.svg'; // Warning icon
        break;
    }

    setTimeout(() => {
      this.close();
    }, timeout);
  }

  close() {
    this.showToast = false;
    this.toastClosed.emit();
  }
}
